import { version } from '../../package.json';
export default version;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/version/index.js
// module id = 1749
// module chunks = 0